import React, { Component } from 'react';
import { withStyles, IconButton, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

const styles = (theme) => ({
  dialogRoot: {
    minHeight: '80vh',
    maxHeight: '80vh',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '100vh',
    },
  },
  dialogTitle: {
    margin: '0',
    padding: '8px 8px 0',
  },
  dialogTitleContent: {
    textAlign: 'center',
    fontSize: '19.5px',
    fontWeight: 'bold',
    color: '#377ac6',
    margin: '0 15px',
    paddingTop: '1em',
    paddingBottom: '1.5em',
    borderBottom: '2px solid #377ac6',
  },
  closeBtn: {
    right: '12px',
    top: '4px',
    color: '#5b5b5b',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  dialogContent: {
    margin: '10px 24px',
  },
  dialogActions: {
    display: 'none',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  contents: {
    padding: theme.spacing(1),
  },
  msgImg: {
    width: '100%',
    height: 'auto',
  },
});

class SupportDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, open, onClose, disableBackdrop } = this.props;
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          onClose={onClose}
          aria-labelledby="welcome-msg-dialog"
          open={open}
          disableBackdropClick={disableBackdrop}
          disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          <DialogTitle className={classes.dialogTitle}>
            <div className={classes.dialogTitleContent}>
              <span>Technical Support</span>
              <IconButton onClick={onClose} className={classes.closeBtn} style={{ position: 'absolute' }}>
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <div style={{ marginBottom: '1em' }}>
              <div style={{ fontWeight: 'bold' }}>※ 기술지원 안내</div>
              <div style={{ paddingLeft: '1em' }}>
                onlinesympo@innon.co.kr
                <br />
                02-1661-2460
              </div>
            </div>
            <div>
              <div style={{ fontWeight: 'bold' }}>※ 학회 및 기타문의</div>
              <div style={{ paddingLeft: '1em' }}>
                manager@kcr2020.com
                <br />
                070-5014-1347
              </div>
            </div>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <div style={{ borderTop: '1px solid rgba(1,1,1,0.2)', margin: '0 15px', paddingTop: '10px' }}>
              <Button onClick={onClose} style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
                닫기
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(SupportDialog);
